// import React from "react";
// import ReactDOM from "react-dom/client";
// // import "./styles/index.scss";
// import Sandbox from "./components/Sandbox/Sandbox.mjs";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<Sandbox />);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();

import ElectronicAssistant from "./components/ElectronicAssistant/ElectronicAssistant.mjs";
import HOC from "./components/HOC/HOC.mjs";
import ReactDOM from "react-dom/client";
import store from "./store/store.mjs";
import { Provider } from "react-redux";
import "./styles/index.scss";

let assistant = document.createElement("div");
assistant.id = "electronic-assistant";
document.body.appendChild(assistant);

const root = ReactDOM.createRoot(document.getElementById("electronic-assistant"));

root.render(
  <Provider store={store}>
    <HOC>
      <ElectronicAssistant />
    </HOC>
  </Provider>
);
